import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchScheduledRateChanges (context, contractId) {
    const path = `contracts/${contractId}/scheduledratechanges`
    const response = await ApiServer.get(path)
    context.commit('setContractScheduledRateChanges', response.data)
    return response.data
  },

  async createScheduledRateChange (_, requestObj) {
    const path = `contracts/${requestObj.contractId}/scheduledratechanges`
    const response = await ApiServer.post(path, requestObj)
    return response.data
  },

  async deleteScheduledRateChanges (_, contractId) {
    const path = `contracts/${contractId}/scheduledratechanges`
    const response = await ApiServer.delete(path)
    return response.data
  }
}
